import React, { Component } from 'react'
import Modal from 'react-modal'
import PropTypes from 'prop-types'
import { customModalStyles } from './styled'
import './index.css'

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root')

class SelectorHitsPerPageModal extends Component {
  shouldComponentUpdate(nextProps) {
    const { modalIsOpen } = this.props
    return nextProps.modalIsOpen !== modalIsOpen
  }

  render() {
    const { modalIsOpen, children, setShowModal } = this.props

    return (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setShowModal(false)}
        style={customModalStyles}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        shouldFocusAfterRender
        closeTimeoutMS={200}
        className="ReactModal__Content--HitsSelector"
      >
        {children}
      </Modal>
    )
  }
}

export default SelectorHitsPerPageModal

SelectorHitsPerPageModal.defaultProps = {
  children: null,
  modalIsOpen: false,
  setShowModal: () => { },
}

SelectorHitsPerPageModal.propTypes = {
  children: PropTypes.object,
  modalIsOpen: PropTypes.bool,
  setShowModal: PropTypes.func,
}
